import { render, staticRenderFns } from "./RegulationDetails.vue?vue&type=template&id=632a6e66&scoped=true&"
import script from "./RegulationDetails.vue?vue&type=script&lang=js&"
export * from "./RegulationDetails.vue?vue&type=script&lang=js&"
import style0 from "./RegulationDetails.vue?vue&type=style&index=0&id=632a6e66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a6e66",
  null
  
)

export default component.exports